<template>
  <div>
    <v-select
      :options="options"
      label="id"
      :disabled="
        finalValue && value && finalValue.id === value.id && value.accept
      "
      v-model="tmp_kostenuebernahme"
      :class="{ 'hide-search': tmp_kostenuebernahme }"
      :clearable="false"
      :searchable="false"
    >
      <template slot="option" slot-scope="option">
        {{ option[$i18n.locale] }}
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option[$i18n.locale] }}
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes" class="text"
          ><font-awesome-icon icon="sort-down"
        /></span>
      </template>
    </v-select>
    <div
      class="mt-2"
      v-if="
        !(finalValue && value && finalValue.id === value.id && value.accept)
      "
    >
      <div class="form-check" v-for="(opt, i) in treeOptions" :key="i">
        <input
          class="form-check-input"
          type="radio"
          :id="i"
          :value="opt"
          v-model="tmp_kostenuebernahme2"
        />
        <label class="form-check-label clinius" :for="i">
          {{ opt.label }}
        </label>
      </div>
    </div>
    <button
      v-if="
        !(
          versicherungsart_locked &&
          finalValue &&
          value &&
          finalValue.id === value.id &&
          value.accept
        )
      "
      @click="handleInput"
      class="btn btn-primary mt-3 d-block"
      :disabled="!tmp_kostenuebernahme"
    >
      {{ $t("actions.auswahl_uebernehmen") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "VersicherungsartTree",
  props: {
    options: { type: Array },
    value: {},
  },
  data() {
    return {
      tmp_kostenuebernahme: this.value,
      tmp_kostenuebernahme2: null,
      decisiontree: {
        // Selbstzahler
        15630217242: [
          {
            label: this.$t("versicherung.selbstzahler.keine_zahnversicherung"),
            value: "15630217242",
          },
          {
            label: this.$t(
              "versicherung.selbstzahler.kv_uebernimmt_keine_zahnarztkosten"
            ),
            value: "15630217242",
          },
          {
            label: this.$t("versicherung.selbstzahler.unfall"),
            value: "15630218EEB",
          },
        ],
        // GKV
        "15FDDBC4667": [
          {
            label: this.$t("versicherung.gkv.gesetzlich_krankenversichert"),
            value: "15FDDBC4667",
          },
          {
            label: this.$t("versicherung.gkv.grenzgaenger"),
            value: "15FDDBC4667",
          },
          {
            label: this.$t("versicherung.gkv.private_zahnzusatzversicherung"),
            value: "15FDDBC4667",
          },
        ],
        // PKV
        "15630218EEB": [
          {
            label: this.$t("versicherung.gkv.privat_krankenversichert"),
            value: "15630218EEB",
          },
          {
            label: this.$t("versicherung.gkv.beihilfeberechtigt"),
            value: "15630218EEB",
          },
          {
            label: this.$t("versicherung.gkv.private_zahnzusatzversicherung"),
            value: "15FDDBC4667",
          },
          {
            label: this.$t("versicherung.pkv.grenzgaenger"),
            value: "15FDDBC4667",
          },
        ],
        // SSO (Standard)
        "15636176FEB": [
          {
            label: this.$t("versicherung.sso.keine_versicherung"),
            value: "15636176FEB",
          },
          {
            label: this.$t("versicherung.sso.zv"),
            value: "15636176FEB",
          },
          {
            label: this.$t("versicherung.sso.sonstig"),
            value: "15FE3B22767",
          },
        ],
        // IV (Sonstige)
        "15FE3B22767": [
          { label: this.$t("versicherung.iv.unfall"), value: "15FE3B22767" },
          {
            label: this.$t("versicherung.iv.invalide"),
            value: "15FE3B22767",
          },
          {
            label: this.$t("versicherung.iv.ev"),
            value: "15FE3B22767",
          },
          {
            label: this.$t("versicherung.iv.sozial"),
            value: "15FE3B22767",
          },
          {
            label: this.$t("versicherung.iv.keins"),
            value: null,
          },
        ],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (v) {
        this.tmp_kostenuebernahme = v;
      },
    },
  },
  computed: {
    treeOptions() {
      if (!this.tmp_kostenuebernahme) return [];
      return this.decisiontree[this.tmp_kostenuebernahme.id];
    },
    finalValue() {
      return this.tmp_kostenuebernahme2
        ? this.options.find((o) => o.id === this.tmp_kostenuebernahme2.value)
        : this.tmp_kostenuebernahme;
    },
    versicherungsart_locked() {
      return this.$route.query.versicherung !== null;
    },
  },
  methods: {
    handleInput() {
      // hier Alert, wenn geändert...
      if (
        this.tmp_kostenuebernahme &&
        this.tmp_kostenuebernahme2 &&
        this.tmp_kostenuebernahme.id != this.tmp_kostenuebernahme2.value
      ) {
        this.$emit("kostenuebernahme_changed");
        this.tmp_kostenuebernahme = this.finalValue;
      }
      this.$emit("input", this.finalValue);
    },
  },
};
</script>
